import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import SectionTitle from "../elements/section-title/SectionTitle";
import SEO from "../common/SEO";
import CounterUpTwo from "../component/counterup/CounterUpTwo";
import AboutThree from "../component/about/AboutThree";
import BcrumbBannerTwo from "../elements/breadcrumb/BcrumbBannerTwo";
import GalleryProp from "../component/gallery/GalleryProp";

const awardsData = [
  {
    src: "/images/galleryucwf/popup_gallery/awards_popup/aw_pic1.webp", // Wide landscape image
    grid: "/images/galleryucwf/grid_images/awards/award_1.webp", // Wide landscape image
    alt: "Landscape image",
  },
  {
    src: "/images/galleryucwf/popup_gallery/awards_popup/aw_pic2.webp", // Square image
    grid: "/images/galleryucwf/grid_images/awards/award_2.webp", // Square image
    alt: "Square image 1",
  },
  {
    src: "/images/galleryucwf/popup_gallery/awards_popup/aw_pic3.webp", // Square image
    grid: "/images/galleryucwf/grid_images/awards/award_3.webp",
    alt: "Square image 2",
  },
  {
    src: "/images/galleryucwf/popup_gallery/awards_popup/aw_pic4.webp", // Tall portrait image
    grid: "/images/galleryucwf/grid_images/awards/award_4.webp",
    alt: "Portrait image 1",
  },
  {
    src: "/images/galleryucwf/popup_gallery/awards_popup/aw_pic5.webp", // Square image
    grid: "/images/galleryucwf/grid_images/awards/award_5.webp",
    alt: "Square image 3",
  },
  {
    src: "/images/galleryucwf/popup_gallery/awards_popup/aw_pic6.webp", // Square image
    grid: "/images/galleryucwf/grid_images/awards/award_6.webp",
    alt: "Square image 4",
  },
  {
    src: "/images/galleryucwf/popup_gallery/awards_popup/aw_pic7.webp", // Wide landscape image
    grid: "/images/galleryucwf/grid_images/awards/award_7.webp",
    alt: "Landscape image 2",
  },
  {
    src: "/images/galleryucwf/popup_gallery/awards_popup/aw_pic8.webp", // Tall portrait image
    grid: "/images/galleryucwf/grid_images/awards/award_8.webp",
    alt: "Portrait image 2",
  },
];
const celebrationsData = [
  {
    src: "/images/galleryucwf/popup_gallery/celebrations_popup/CEL_1.webp", // Wide landscape image
    grid: "/images/galleryucwf/grid_images/celebrations/cel_1.webp",
    alt: "Landscape image",
  },
  {
    src: "/images/galleryucwf/popup_gallery/celebrations_popup/CEL_2.webp", // Square image
    grid: "/images/galleryucwf/grid_images/celebrations/cel_2.webp",
    alt: "Square image 1",
  },
  {
    src: "/images/galleryucwf/popup_gallery/celebrations_popup/CEL_3.webp", // Square image
    grid: "/images/galleryucwf/grid_images/celebrations/cel_3.webp",
    alt: "Square image 2",
  },
  {
    src: "/images/galleryucwf/popup_gallery/celebrations_popup/CEL_4.webp", // Tall portrait image
    grid: "/images/galleryucwf/grid_images/celebrations/cel_4.webp",
    alt: "Portrait image 1",
  },
  {
    src: "/images/galleryucwf/popup_gallery/celebrations_popup/CEL_5.webp", // Square image
    grid: "/images/galleryucwf/grid_images/celebrations/cel_5.webp",
    alt: "Square image 3",
  },
  {
    src: "/images/galleryucwf/popup_gallery/celebrations_popup/CEL_6.webp", // Square image
    grid: "/images/galleryucwf/grid_images/celebrations/cel_6.webp",
    alt: "Square image 4",
  },
  {
    src: "/images/galleryucwf/popup_gallery/celebrations_popup/CEL_7.webp", // Wide landscape image
    grid: "/images/galleryucwf/grid_images/celebrations/cel_7.webp",
    alt: "Landscape image 2",
  },
  {
    src: "/images/galleryucwf/popup_gallery/celebrations_popup/CEL_8.webp", // Tall portrait image
    grid: "/images/galleryucwf/grid_images/celebrations/cel_8.webp",
    alt: "Portrait image 2",
  },
  {
    src: "/images/galleryucwf/popup_gallery/celebrations_popup/CEL_9.webp", // Tall portrait image
    grid: "/images/galleryucwf/grid_images/celebrations/cel_9.webp",
    alt: "Portrait image 2",
  },
  {
    src: "/images/galleryucwf/popup_gallery/celebrations_popup/CEL_10.webp", // Tall portrait image
    grid: "/images/galleryucwf/grid_images/celebrations/cel_10.webp",
    alt: "Portrait image 2",
  },
  {
    src: "/images/galleryucwf/popup_gallery/celebrations_popup/CEL_11.webp", // Tall portrait image
    grid: "/images/galleryucwf/grid_images/celebrations/cel_11.webp",
    alt: "Portrait image 2",
  },
];
const HousekeepingCrewData = [
  {
    src: "/images/galleryucwf/popup_gallery/housekeepingcrew_popup/HouseKeep_1.webp ", // Wide landscape image
    grid: "/images/galleryucwf/grid_images/housekeepingCrew/housekeep1.webp",
    alt: "Landscape image",
  },
  {
    src: "/images/galleryucwf/popup_gallery/housekeepingcrew_popup/HouseKeep_2.webp ", // Square image
    grid: "/images/galleryucwf/grid_images/housekeepingCrew/housekeep2.webp",
    alt: "Square image 1",
  },
  {
    src: "/images/galleryucwf/popup_gallery/housekeepingcrew_popup/HouseKeep_3.webp ", // Square image
    grid: "/images/galleryucwf/grid_images/housekeepingCrew/housekeep3.webp",
    alt: "Square image 2",
  },
  {
    src: "/images/galleryucwf/popup_gallery/housekeepingcrew_popup/HouseKeep_4.webp ", // Tall portrait image
    grid: "/images/galleryucwf/grid_images/housekeepingCrew/housekeep4.webp",
    alt: "Portrait image 1",
  },
  {
    src: "/images/galleryucwf/popup_gallery/housekeepingcrew_popup/HouseKeep_5.webp ", // Square image
    grid: "/images/galleryucwf/grid_images/housekeepingCrew/housekeep5.webp",
    alt: "Square image 3",
  },
  {
    src: "/images/galleryucwf/popup_gallery/housekeepingcrew_popup/HouseKeep_6.webp ", // Square image
    grid: "/images/galleryucwf/grid_images/housekeepingCrew/housekeep6.webp",
    alt: "Square image 4",
  },
  {
    src: "/images/galleryucwf/popup_gallery/housekeepingcrew_popup/HouseKeep_7.webp ", // Wide landscape image
    grid: "/images/galleryucwf/grid_images/housekeepingCrew/housekeep7.webp",
    alt: "Landscape image 2",
  },
  {
    src: "/images/galleryucwf/popup_gallery/housekeepingcrew_popup/HouseKeep_8.webp ", // Tall portrait image
    grid: "/images/galleryucwf/grid_images/housekeepingCrew/housekeep8.webp",
    alt: "Portrait image 2",
  },
  {
    src: "/images/galleryucwf/popup_gallery/housekeepingcrew_popup/HouseKeep_9.webp ", // Tall portrait image
    grid: "/images/galleryucwf/grid_images/housekeepingCrew/housekeep9.webp",
    alt: "Portrait image 2",
  },
  {
    src: "/images/galleryucwf/popup_gallery/housekeepingcrew_popup/HouseKeep_10.webp ", // Tall portrait image
    grid: "/images/galleryucwf/grid_images/housekeepingCrew/housekeep10.webp",
    alt: "Portrait image 2",
  },
];
const technicalExpertiseData = [
  {
    src: "/images/galleryucwf/popup_gallery/technicalexpertise_popup/techExpert_1.webp", // Wide landscape image
    grid: "/images/galleryucwf/grid_images/technicalexpertise/techexpert1.webp",
    alt: "Landscape image",
  },
  {
    src: "/images/galleryucwf/popup_gallery/technicalexpertise_popup/techExpert_2.webp", // Square image
    grid: "/images/galleryucwf/grid_images/technicalexpertise/techexpert2.webp",
    alt: "Square image 1",
  },
  {
    src: "/images/galleryucwf/popup_gallery/technicalexpertise_popup/techExpert_3.webp", // Square image
    grid: "/images/galleryucwf/grid_images/technicalexpertise/techexpert3.webp",
    alt: "Square image 2",
  },
  {
    src: "/images/galleryucwf/popup_gallery/technicalexpertise_popup/techExpert_4.webp", // Tall portrait image
    grid: "/images/galleryucwf/grid_images/technicalexpertise/techexpert4.webp",
    alt: "Portrait image 1",
  },
  {
    src: "/images/galleryucwf/popup_gallery/technicalexpertise_popup/techExpert_5.webp", // Square image
    grid: "/images/galleryucwf/grid_images/technicalexpertise/techexpert5.webp",
    alt: "Square image 3",
  },
  {
    src: "/images/galleryucwf/popup_gallery/technicalexpertise_popup/techExpert_6.webp", // Square image
    grid: "/images/galleryucwf/grid_images/technicalexpertise/techexpert6.webp",
    alt: "Square image 4",
  },
  {
    src: "/images/galleryucwf/popup_gallery/technicalexpertise_popup/techExpert_7.webp", // Wide landscape image
    grid: "/images/galleryucwf/grid_images/technicalexpertise/techexpert7.webp",
    alt: "Landscape image 2",
  },
  {
    src: "/images/galleryucwf/popup_gallery/technicalexpertise_popup/techExpert_8.webp", // Tall portrait image
    grid: "/images/galleryucwf/grid_images/technicalexpertise/techexpert8.webp",
    alt: "Portrait image 2",
  },
  {
    src: "/images/galleryucwf/popup_gallery/technicalexpertise_popup/techExpert_9.webp", // Tall portrait image
    grid: "/images/galleryucwf/grid_images/technicalexpertise/techexpert9.webp",
    alt: "Portrait image 2",
  },
];
const ucwfTeamData = [
  {
    src: "/images/galleryucwf/popup_gallery/ucwfteam_popup/Team_1.webp", // Wide landscape image
    grid: "/images/galleryucwf/grid_images/ucwfteam/team1.webp",
    alt: "Landscape image",
  },
  {
    src: "/images/galleryucwf/popup_gallery/ucwfteam_popup/Team_2.webp", // Square image
    grid: "/images/galleryucwf/grid_images/ucwfteam/team2.webp",
    alt: "Square image 1",
  },
  {
    src: "/images/galleryucwf/popup_gallery/ucwfteam_popup/Team_3.webp", // Square image
    grid: "/images/galleryucwf/grid_images/ucwfteam/team3.webp",
    alt: "Square image 2",
  },
  {
    src: "/images/galleryucwf/popup_gallery/ucwfteam_popup/Team_4.webp", // Tall portrait image
    grid: "/images/galleryucwf/grid_images/ucwfteam/team4.webp",
    alt: "Portrait image 1",
  },
  {
    src: "/images/galleryucwf/popup_gallery/ucwfteam_popup/Team_5.webp", // Square image
    grid: "/images/galleryucwf/grid_images/ucwfteam/team5.webp",
    alt: "Square image 3",
  },
  {
    src: "/images/galleryucwf/popup_gallery/ucwfteam_popup/Team_6.webp", // Square image
    grid: "/images/galleryucwf/grid_images/ucwfteam/team6.webp",
    alt: "Square image 4",
  },
  {
    src: "/images/galleryucwf/popup_gallery/ucwfteam_popup/Team_7.webp", // Wide landscape image
    grid: "/images/galleryucwf/grid_images/ucwfteam/team7.webp",
    alt: "Landscape image 2",
  },
  {
    src: "/images/galleryucwf/popup_gallery/ucwfteam_popup/Team_8.webp", // Tall portrait image
    grid: "/images/galleryucwf/grid_images/ucwfteam/team8.webp",
    alt: "Portrait image 2",
  },
  {
    src: "/images/galleryucwf/popup_gallery/ucwfteam_popup/Team_9.webp", // Tall portrait image
    grid: "/images/galleryucwf/grid_images/ucwfteam/team9.webp",
    alt: "Portrait image 2",
  },
  {
    src: "/images/galleryucwf/popup_gallery/ucwfteam_popup/Team_10.webp", // Tall portrait image
    grid: "/images/galleryucwf/grid_images/ucwfteam/team10.webp",
    alt: "Portrait image 2",
  },
];

const Gallery = () => {
  const location = useLocation();
  const [activeSection, setActiveSection] = useState("awards"); // Default to awards

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Handle URL hash changes to set the active section
  useEffect(() => {
    const hash = location.hash.replace("#", "");
    if (hash) {
      const validSections = [
        "awards",
        "celebrations",
        "housekeepingcrew",
        "technical-expertise",
        "ucwf-team",
      ];
      if (validSections.includes(hash)) {
        setActiveSection(hash);

        // Scroll to the section after a short delay to ensure rendering is complete
        setTimeout(() => {
          const element = document.getElementById(hash);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        }, 100);
      }
    }
  }, [location]);
  return (
    <>
      <SEO title="Gallery" />
      <main className="main-wrapper">
        <HeaderOne />
        <BcrumbBannerTwo title="Gallery" paragraph="" styleClass="" />

        <div
          className="service-scroll-navigation-area"
          style={{ paddingTop: isMobile ? "40px" : "90px" }}
        >
          {/* images gallery tab */}
          <div className="container ">
            {" "}
            {/* Change to container-fluid for full width */}
            <div className="row g-0">
              {" "}
              {/* Remove g-1 and add g-0 to eliminate gaps */}
              <div className="col">
                <div className="gallery-tabs d-flex justify-content-between">
                  {/* Each tab as a flex item */}
                  <div
                    className={`gallery-tab-item ${
                      activeSection === "awards" ? "active" : ""
                    }`}
                  >
                    <div
                      className="gallery-tab-image position-relative"
                      onClick={() => setActiveSection("awards")}
                    >
                      <img
                        src="/images/galleryucwf/tabs/awards-tab.webp"
                        alt="Awards Gallery"
                        className="img-fluid w-100"
                        loading="lazy"
                      />
                      <div className="gallery-tab-title position-absolute w-100 h-100 d-flex justify-content-center align-items-center">
                        Awards
                      </div>
                    </div>
                  </div>

                  <div
                    className={`gallery-tab-item ${
                      activeSection === "celebrations" ? "active" : ""
                    }`}
                  >
                    <div
                      className="gallery-tab-image position-relative"
                      onClick={() => setActiveSection("celebrations")}
                    >
                      <img
                        src="/images/galleryucwf/tabs/celebrations-tab.webp"
                        alt="Celebrations Gallery"
                        className="img-fluid w-100"
                        loading="lazy"
                      />
                      <div className="gallery-tab-title position-absolute w-100 h-100 d-flex justify-content-center align-items-center">
                        Celebrations
                      </div>
                    </div>
                  </div>

                  <div
                    className={`gallery-tab-item ${
                      activeSection === "housekeepingcrew" ? "active" : ""
                    }`}
                  >
                    <div
                      className="gallery-tab-image position-relative"
                      onClick={() => setActiveSection("housekeepingcrew")}
                    >
                      <img
                        src="/images/galleryucwf/tabs/housekeeping-tab.webp"
                        alt="HousekeepingCrew Gallery"
                        className="img-fluid w-100"
                        loading="lazy"
                      />
                      <div className="gallery-tab-title position-absolute w-100 h-100 d-flex justify-content-center align-items-center">
                        Housekeeping Crew
                      </div>
                    </div>
                  </div>

                  <div
                    className={`gallery-tab-item ${
                      activeSection === "technical-expertise" ? "active" : ""
                    }`}
                  >
                    <div
                      className="gallery-tab-image position-relative"
                      onClick={() => setActiveSection("technical-expertise")}
                    >
                      <img
                        src="/images/galleryucwf/tabs/technical-tab.webp"
                        alt="Technical Expertise Gallery"
                        className="img-fluid w-100"
                        loading="lazy"
                      />
                      <div className="gallery-tab-title position-absolute w-100 h-100 d-flex justify-content-center align-items-center">
                        Technical Expertise
                      </div>
                    </div>
                  </div>

                  <div
                    className={`gallery-tab-item ${
                      activeSection === "ucwf-team" ? "active" : ""
                    }`}
                  >
                    <div
                      className="gallery-tab-image position-relative"
                      onClick={() => setActiveSection("ucwf-team")}
                    >
                      <img
                        src="/images/galleryucwf/tabs/ucwfteam-tab.webp"
                        alt="UCWF Team Gallery"
                        className="img-fluid w-100"
                        loading="lazy"
                      />
                      <div className="gallery-tab-title position-absolute w-100 h-100 d-flex justify-content-center align-items-center">
                        UCWF Team
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {activeSection === "awards" && (
            <div
              className=""
              id="awards"
              style={{ padding: isMobile ? " 0 0" : "90px 0 0px" }}
            >
              <div className="container">
                <SectionTitle
                  subtitle=""
                  title="Awards"
                  description=""
                  textAlignment="heading-left"
                  textColor=""
                />
                <div className="row">
                  <GalleryProp
                    colSize="col-lg-4 col-md-6"
                    serviceStyle="service-style-2"
                    galleryData={awardsData}
                  />
                </div>
              </div>
            </div>
          )}

          {activeSection === "celebrations" && (
            <div
              className=""
              id="celebrations"
              style={{ padding: isMobile ? " 0 0" : "90px 0 0px" }}
            >
              <div className="container">
                <SectionTitle
                  subtitle=""
                  title="Celebrations"
                  description=""
                  textAlignment="heading-left"
                  textColor=""
                />
                <div className="row">
                  <GalleryProp
                    colSize="col-lg-4 col-md-6"
                    serviceStyle="service-style-2"
                    galleryData={celebrationsData}
                  />
                </div>
              </div>
            </div>
          )}

          {activeSection === "housekeepingcrew" && (
            <div
              className=" "
              id="housekeepingcrew"
              style={{ padding: isMobile ? " 0 0" : "90px 0 0px" }}
            >
              <div className="container">
                <SectionTitle
                  subtitle=""
                  title="Housekeeping Crew"
                  description=""
                  textAlignment="heading-left"
                  textColor=""
                />
                <div className="row">
                  <GalleryProp
                    colSize="col-lg-4 col-md-6"
                    serviceStyle="service-style-2"
                    galleryData={HousekeepingCrewData}
                  />
                </div>
              </div>
            </div>
          )}

          {activeSection === "technical-expertise" && (
            <div
              className=""
              id="technical-expertise"
              style={{ padding: isMobile ? " 0 0" : "90px 0 0px" }}
            >
              <div className="container">
                <SectionTitle
                  subtitle=""
                  title="Technical Expertise"
                  description=""
                  textAlignment="heading-left"
                  textColor=""
                />
                <div className="row">
                  <GalleryProp
                    colSize="col-lg-4 col-md-6"
                    serviceStyle="service-style-2"
                    galleryData={technicalExpertiseData}
                  />
                </div>
              </div>
            </div>
          )}

          {activeSection === "ucwf-team" && (
            <div
              className=" "
              id="ucwf-team"
              style={{ padding: isMobile ? " 0 0" : "90px 0 0px" }}
            >
              <div className="container">
                <SectionTitle
                  subtitle=""
                  title="UCWF Team"
                  description=""
                  textAlignment="heading-left"
                  textColor=""
                />
                <div className="row">
                  <GalleryProp
                    colSize="col-lg-4 col-md-6"
                    serviceStyle="service-style-2"
                    galleryData={ucwfTeamData}
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        <CounterUpTwo />
        <AboutThree />
        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default Gallery;
